import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    display: 'flex',
  },
  leftColumn: {
    flex: 1,
    marginRight: theme.spacing(5),
  },
  rightColumn: {
    flex: 1,
  },
}))

export default useStyles
